// Library Methods
import i18next from "i18next";

// Components
import Box from "@mui/material/Box";
import OperatingManualContent from "../OperatingManualContent/OperatingManualContent";

import visualAcuity1Img from "src/assets/images/operating-manual/appendix-d/visual-acuity-1.png";
import visualAcuity1FrImg from "src/assets/images/operating-manual/appendix-d/visual-acuity-1-fr.png";
import visualAcuity2Img from "src/assets/images/operating-manual/appendix-d/visual-acuity-2.png";
import visualAcuity2FrImg from "src/assets/images/operating-manual/appendix-d/visual-acuity-2-fr.png";
import visualAcuity3Img from "src/assets/images/operating-manual/appendix-d/visual-acuity-3.png";
import visualAcuity3FrImg from "src/assets/images/operating-manual/appendix-d/visual-acuity-3-fr.png";

// Config
import { priorityLanguageMap } from "src/config/languages";

type AppendixDType = {
  title: string;
};

const AppendixD = ({ title }: AppendixDType) => {
  const currentLang = i18next.language as keyof typeof priorityLanguageMap;

  return (
    <OperatingManualContent title={title}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        <img
          src={currentLang === "fr" ? visualAcuity1FrImg : visualAcuity1Img}
          width="100%"
          alt="va-1"
        />
        <img
          src={currentLang === "fr" ? visualAcuity2FrImg : visualAcuity2Img}
          width="100%"
          alt="va-2"
        />
        <img
          src={currentLang === "fr" ? visualAcuity3FrImg : visualAcuity3Img}
          width="100%"
          alt="va-3"
        />
      </Box>
    </OperatingManualContent>
  );
};

export default AppendixD;
